export const config = {
  data() {
    return {
      columns: []
    };
  },
  mounted() {
    let columns = [
      {
        type: 'index',
        title: '序号',
        align: 'center',
        width: '80'
      },
      {
        title: '继续率月份',
        key: 'needPayDate',
        minWidth: 140,
        align: 'center'
      },
      {
        title: '业务员',
        key: 'groupName',
        minWidth: 140,
        align: 'center',
        render(h, params) {
          const row = params.row;
          return (
            <span>
              {row.staffNo}/{row.salesmanName}
            </span>
          );
        }
      },
      {
        title: '业务员所属机构',
        key: 'orgName',
        minWidth: 140,
        align: 'center'
      },
      {
        title: '继续率指标',
        key: 'payNum',
        minWidth: 140,
        align: 'center',
        render(h, params) {
          const map = {
            '2': 'R13',
            '3': 'R25',
            '4': 'R37',
            '5': 'R49'
          };
          return <span>{map[params.row.payNum]}</span>;
        }
      },
      {
        title: '继续率',
        key: 'rate',
        minWidth: 140,
        align: 'center',
        render(h, params) {
          return <span>{params.row.renewalRateStr}</span>;
        }
      },
      {
        title: '应交保费（元）',
        key: 'insureFee',
        align: 'center',
        minWidth: 180,
        render(h, params) {
          return <span>{params.row.settlementFee}</span>;
        }
      },
      {
        title: '承保数据范围',
        key: 'insureTimeBegin',
        align: 'center',
        minWidth: 180,
        render(h, params) {
          const row = params.row;
          const date = row.startTimeStart.substring(0, 10);
          const endDate = row.startTimeEnd.substring(0, 10);
          return (
            <span>
              {date} 至 {endDate}
            </span>
          );
        }
      },
      {
        title: '实收保费（元）',
        key: 'receiptFee',
        align: 'center',
        minWidth: 180,
        render(h, params) {
          return <span>{params.row.settlementPayFee}</span>;
        }
      },
      {
        title: '实收数据范围',
        key: 'receiptTimeBegin',
        align: 'center',
        minWidth: 180,
        render(h, params) {
          const row = params.row;
          const date = row.needPayDateStart.substring(0, 10);
          const endDate = row.needPayDateEnd.substring(0, 10);
          return (
            <span>
              {date} 至 {endDate}
            </span>
          );
        }
      },
      {
        title: '操作',
        slot: 'action',
        align: 'center',
        width: 100,
        fixed: 'right'
      }
    ];

    this.columns = columns;
  },
  methods: {}
};
